import type { ContactFormData } from "@/lib/contact-form-schema"
import { contactSubmitErrorMessage } from "@/lib/contact-intake"
import { useState } from "react"

interface UseContactFormReturn {
  isSubmitting: boolean
  isSuccess: boolean
  error: string | null
  submitForm: (data: ContactFormData) => Promise<void>
  resetForm: () => void
}

export function useContactForm(): UseContactFormReturn {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const submitForm = async (data: ContactFormData) => {
    setIsSubmitting(true)
    setError(null)
    setIsSuccess(false)

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })

      const result = await response.json()

      if (!response.ok) {
        throw new Error(result.error || "Failed to send message")
      }

      setIsSuccess(true)
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : contactSubmitErrorMessage({
              ok: false,
              code: "delivery",
              message: "An unexpected error occurred",
            })
      )
    } finally {
      setIsSubmitting(false)
    }
  }

  const resetForm = () => {
    setIsSuccess(false)
    setError(null)
  }

  return {
    isSubmitting,
    isSuccess,
    error,
    submitForm,
    resetForm,
  }
}
